import { render } from "./NotvalidUser.vue?vue&type=template&id=21413374&scoped=true"
import script from "./NotvalidUser.vue?vue&type=script&lang=js"
export * from "./NotvalidUser.vue?vue&type=script&lang=js"

import "./NotvalidUser.vue?vue&type=style&index=0&id=21413374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21413374"]])

export default __exports__